import * as React from 'react';
import Head from '~/common/layout/Head';

type Props = {
  title: string,
  filter: any,
  onCreate: () => void;
  onFilter: (any) => void;
}

class UserListHeader extends React.Component<Props> {
  filterRef;

  constructor(props) {
    super(props);
    this.filterRef = React.createRef();
  }

  onCreate = (e) => {
    e.preventDefault();

    this.props.onCreate();
  };

  onSearch = (e) => {
    e.preventDefault();

    this.props.onFilter(this.filterRef.current.value);
  };

  render() {
    const { title, filter } = this.props;

    return (
      <Head headTitle={title}>
        <form onSubmit={this.onSearch}>
          <div className="input--search">
            <a
              onClick={this.onSearch}
              href="javascript:void(null)"
              className="input__icon input--search__btn"
            >
              <span className="i i-search" />
            </a>
            <input
              type="text"
              placeholder="Search"
              ref={this.filterRef}
              defaultValue={filter && filter.q}
            />
          </div>
        </form>

        <a
          onClick={this.onCreate}
          href="javascript:void(null)"
          className="btn btn--secn btn--lg">Create</a>
      </Head>
    );
  }
}

export default UserListHeader;
